module.exports = __webpack_public_path__ + "img/slide00.85b5b24f.jpg";